import React from 'react';

const NodePanel = ({ onAddNode }) => {
  const nodeTypes = [
    { 
      type: 'message', 
      label: 'Message Node', 
      description: 'Plays a message to the user',
      icon: '💬'
    },
    { 
      type: 'decision', 
      label: 'Decision Node', 
      description: 'Branch flow based on user intent',
      icon: '🔀'
    },
    { 
      type: 'api', 
      label: 'API Node', 
      description: 'Make API calls with payloads',
      icon: '🔌'
    },
    { 
      type: 'faq', 
      label: 'FAQ Node', 
      description: 'Handle FAQ responses',
      icon: '❓'
    }
  ];

  return (
    <div className="node-panel">
      <h3>Nodes</h3>
      <p className="panel-description">Drag and drop nodes to create your flow</p>
      
      <div className="node-list">
        {nodeTypes.map(node => (
          <div 
            key={node.type}
            className={`node node-${node.type}`}
            onClick={() => onAddNode(node.type)}
            draggable
            onDragStart={(e) => {
              e.dataTransfer.setData('application/reactflow', node.type);
              e.dataTransfer.effectAllowed = 'move';
            }}
          >
            <div className="node-icon">{node.icon}</div>
            <div className="node-content">
              <h4>{node.label}</h4>
              <p>{node.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NodePanel; 